import { createPendingSmsStore } from '@/stores/createPendingSmsStore';

export const usePendingSmsStore = createPendingSmsStore();
